module.exports = __webpack_public_path__ + "img/boiler-S-fire.f7b3d7d7.png";